module.exports = __webpack_public_path__ + "static/media/power-pricer.2667d31e.png";